import {
    gsap
} from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

let mm, tl, observer;

export default () => ({
    from: 0,
    to: 0,
    start: "top bottom",
    end: "bottom top",
    trigger: null,
    endtrigger: null,

    init() {
        this.from = this.$el.dataset.from;
        this.to = this.$el.dataset.to;

        if(this.$el.dataset.start !== undefined ){
            this.start = this.$el.dataset.start;
        }
        if(this.$el.dataset.end !== undefined ){
            this.end = this.$el.dataset.end;
        }
        if(this.$el.dataset.trigger !== undefined ){
            const triggerExpression = new Function(`"use strict"; return (${this.$el.dataset.trigger});`);
            this.trigger = triggerExpression.call(this);
        } else { this.trigger = this.$el; }
        if(this.$el.dataset.endtrigger !== undefined ){
            const triggerExpression = new Function(`"use strict"; return (${this.$el.dataset.endtrigger});`);
            this.endtrigger = triggerExpression.call(this);
        } else { this.endtrigger = this.$el; }
        

        if(this.$el.dataset.disablemobile !== undefined ){
            mm = gsap.matchMedia();
            mm.add("(min-width: 1024px)", () => {
                this.createTimeline();
            });
        } else {
            this.createTimeline();
        }

        //OBSERVE
        observer = new ResizeObserver(() => {
            if(tl && tl.scrollTrigger){
                tl.scrollTrigger.refresh();
            }
        });
        observer.observe(document.body);
    },
    createTimeline(){
        this.$el.style.willChange = 'transform';

        tl = gsap.timeline({
            scrollTrigger: {
                trigger: this.trigger,
                endTrigger: this.endtrigger,
                markers: false,
                pin: false,
                start: this.start,
                end: this.end,
                scrub: true,
            }
        });

        tl.fromTo(this.$el, {
            rotation: this.from,
            ease: "linear"
        },
        {
            rotation: this.to,
            ease: "linear"
        });
    },
});